module.exports = __webpack_public_path__ + "media/ordograja_k.b71a8877.mp3";